import './style.scss'
import React from 'react'
import styled from 'styled-components'
import { tokens, rem, UIProps, IconPosition } from 'src/componentv2/Base/ui'

export interface BadgeProps extends UIProps {
    children?: React.ReactNode
    icon?: React.ReactNode
    iconPosition?: IconPosition
    onClick?: () => void
}

const StyledBadge = styled.span<BadgeProps>`
    display: inline-flex;
    align-items: center;
    gap: 0.6rem;
    border-radius: ${({ radius }) => rem(radius) ?? '999rem'};
    background: ${({ bgColor }) => bgColor ?? tokens.white};
    color: ${({ color }) => color ?? tokens.textDark};
    border: ${({ borderColor }) =>
    borderColor ? `1px solid ${borderColor}` : 'none'};
    box-shadow: ${({ shadow }) => shadow ?? 'none'};
    font-size: ${({ fontSize }) => rem(fontSize) ?? '1.3rem'};
    font-weight: ${({ fontWeight }) => fontWeight ?? '500'};
    padding: ${({ paddingY, paddingX }) =>
    `${rem(paddingY) ?? '0.7rem'} ${rem(paddingX) ?? '1.4rem'}`};
    cursor: ${({ cursor, onClick }) => cursor ?? (onClick ? 'pointer' : 'default')};
    white-space: nowrap;
`

export const Badge: React.FC<BadgeProps> = ({
                                                children, icon, iconPosition = 'left', className = '', ...rest
                                            }) => (
    <StyledBadge className={`badge ${className}`} {...rest}>
        {icon && iconPosition === 'left' && (
            <span className="badge__icon">{icon}</span>
        )}
        {children}
        {icon && iconPosition === 'right' && (
            <span className="badge__icon">{icon}</span>
        )}
    </StyledBadge>
)

export default Badge